import { render, staticRenderFns } from "./BildModal.vue?vue&type=template&id=4f03faec"
import script from "./BildModal.vue?vue&type=script&lang=js"
export * from "./BildModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports